import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Section = styled.section`
  display: flex;
  min-height: 1013px;
  background: ${themeGet('colors.background')};
`;

export const TilePlaceholder = styled.div`
  background: ${themeGet('colors.black.5')};
  border: 1px dashed ${themeGet('colors.border')};
  box-sizing: border-box;
  border-radius: 8px;
  height: 347px;
  width: 257px;
`;

export const Circle = styled.div`
  &:before {
    background-size: contain;
    background-repeat: no-repeat;
    background-color: ${props => props.color};
    border-radius: 10px;
    content: ' ';
    display: ${props => (props.color ? 'block' : 'none')};
    margin-right: 8px;
    height: 10px;
    width: 10px;
  }
  + div {
    color: ${props =>
      !props.isSettings
        ? themeGet('colors.black.80')
        : themeGet('colors.primary.100')};
  }
`;

export const SelectWrapper = styled.div`
  margin: 0 0 0 16px;
  max-width: 185px;

  &:first-child {
    margin: 0;
  }
`;

export const MonthWrapper = styled(SelectWrapper)`
  min-width: 141px;
`;

export const YearWrapper = styled(SelectWrapper)`
  min-width: 124px;
`;

export const TopicWrapper = styled(SelectWrapper)`
  min-width: 132px;
`;

export const AudienceWrapper = styled(SelectWrapper)`
  min-width: 162px;
`;

export const StyledOption = styled.div`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StatsPlaceholder = styled(TilePlaceholder)`
  height: 24px;
  margin-top: 8px;
`;

export const ClientAdminTilesContainerWrapper = styled.div`
  margin: 24px;
`;

export const TilesWrapper = styled.section`
  background-color: ${themeGet('colors.white')} !important;
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px;
  min-height: 1013px;
  padding: 16px 24px;
  margin: 0;
  display: flex;
`;
